import { Box } from "@mui/material";
import Header from "../../components/Header";
import MyCustomers from "./dashboard-components/my-customers";
import LicenseSold from "./dashboard-components/license_selled";
import OnlineLecs from "./dashboard-components/onlineLecs";
import { useState, useEffect } from "react";
import API from "../../api/index";
import LicenseExpT from "./dashboard-components/expiredTable";
import { Grid } from "@mui/material";
import ResellerCode from "./dashboard-components/resellerCode";
const DashboardC = ({ setCustomerName, setTimeZone, setLecsInfo }) => {
  const [resInfo, setResInfo] = useState({});
  const [onlineLecs, setOnlineLecs] = useState(0);

  useEffect(() => {
    API.getResellerInfo({}).then((response) => {
      setResInfo(response.data);
    });
    API.getOnlineLecs({}).then((res) => {
      
      setOnlineLecs(res.data);
    })
  }, []);

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="RESELLER OVERVIEW" subtitle="" />
      </Box>

      {/* GRID & CHARTS */}
      <Grid container spacing={2}>
        {/* ROW 1 */}
        <Grid xs={12} size={3}>
          <MyCustomers customers={resInfo.customers} />
        </Grid>
        <Grid xs={12} size={3}>
          <LicenseSold licenseSold={resInfo.license_sold} />
        </Grid>
        <Grid xs={12} size={3}>
          <ResellerCode resCode={resInfo.resCode}/>
        </Grid>
        <Grid xs={12} size={3}>
          <OnlineLecs total={onlineLecs.total} online={onlineLecs.online} />
        </Grid>

        <Grid sx={{height: 520}} xs={12} size={12}>
          <LicenseExpT />
        </Grid>
        
      </Grid>
    </Box>
  );
};

export default DashboardC;
